import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="not-found-container">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <a href="/home">Home Page</a>
    </div>
  `,
  styles: [`
    .not-found-container {
      text-align: center;
      margin-top: 80px;
    }
    h1 {
      font-size: 2.5rem;
      color: #d32f2f;
    }
    p {
      font-size: 1.2rem;
      margin-bottom: 24px;
    }
    a {
      color: #1976d2;
      text-decoration: underline;
      font-size: 1rem;
    }
  `]
})
export class NotFoundComponent {
}
